import { render, staticRenderFns } from "./modules_change.vue?vue&type=template&id=2b9e7492&scoped=true&"
import script from "./modules_change.vue?vue&type=script&lang=js&"
export * from "./modules_change.vue?vue&type=script&lang=js&"
import style0 from "./modules_change.vue?vue&type=style&index=0&id=2b9e7492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e7492",
  null
  
)

export default component.exports